/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onUpsertCompletionResponse = /* GraphQL */ `
  subscription OnUpsertCompletionResponse($request_id: String) {
    onUpsertCompletionResponse(request_id: $request_id) {
      response
      request_id
    }
  }
`;
export const onUpsertContactTranscription = /* GraphQL */ `
  subscription OnUpsertContactTranscription($contactId: String!) {
    onUpsertContactTranscription(contactId: $contactId) {
      contactId
      createdAt
      transcriptions {
        channelId
        endTime
        startTime
        transcript
      }
      updatedAt
    }
  }
`;
export const onUpsertProtocol = /* GraphQL */ `
  subscription OnUpsertProtocol($id: Int) {
    onUpsertProtocol(id: $id) {
      protocols {
        created_at
        id
        protocol_bucket
        protocol_extract_json
        protocol_key
        protocol_name
        protocol_url
        subject_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        updated_at
      }
      rankings {
        contact_id
        id
        row_num
      }
      total_count
    }
  }
`;
export const onUpsertStudy = /* GraphQL */ `
  subscription OnUpsertStudy($id: Int) {
    onUpsertStudy(id: $id) {
      rankings {
        contact_id
        id
        row_num
      }
      studies {
        agent_booked_appointment_text
        agent_needs_callback_text
        agent_precall_text
        ava_bot_alias_id
        ava_bot_config
        ava_bot_id
        ava_state_machine
        ccid
        contact_flow_id
        created_at
        end_date
        id
        protocol_extract_json
        site_description
        site_id
        site_name
        sponsor_id
        sponsor_name
        start_date
        status
        study_category
        study_cc_visits {
          id
          name
        }
        study_description
        study_name
        subject_count
        subject_protocol_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        text_agent_name
        updated_at
        visit_name
        voice_agent_name
      }
      total_count
    }
  }
`;
export const onUpsertSubjectContact = /* GraphQL */ `
  subscription OnUpsertSubjectContact($contact_id: String!) {
    onUpsertSubjectContact(contact_id: $contact_id) {
      ai_platform
      channel
      city
      contact_id
      created_at
      duration_seconds
      ended_at
      first_name
      full_name_first
      full_name_last
      last_name
      next_task_id
      next_touchpoint
      outcome
      outcomes
      phone_number
      purpose
      recording_bucket
      recording_key
      recording_url
      recruitment_id
      recruitment_source_name
      started_at
      subject_id
      summary
      transcript_bucket
      transcript_json
      transcript_key
      transcript_url
      updated_at
      wss_url
    }
  }
`;
export const onUpsertTableChangelog = /* GraphQL */ `
  subscription OnUpsertTableChangelog($subject_id: Int) {
    onUpsertTableChangelog(subject_id: $subject_id) {
      queue_task {
        alias
        channel
        created_at
        estimated_first_attempt_at
        first_name
        full_name_first
        full_name_last
        id
        last_name
        next_retry_at
        next_task_id
        next_touchpoint
        recruitment_id
        recruitment_source_name
        status
        subject_id
        task_id
        updated_at
        workflow_id
      }
      recruitment_sources {
        contact_address_line1
        contact_address_line2
        contact_city
        contact_country
        contact_email_address
        contact_name
        contact_phone_number
        contact_postal_code
        contact_state
        created_at
        external_id
        id
        is_deletable
        parent_id
        parent_id_source_description
        parent_id_source_name
        source_description
        source_name
        subject_count
        total_budget
        total_spend
        updated_at
      }
      segments {
        age_max
        age_min
        allergies {
          allergen_description
          allergen_type
          cc_allergen_id
          ccid
          created_at
          description
          id
          is_default
          name
          updated_at
        }
        bmi_category
        bmi_max
        bmi_min
        conditions {
          category_description
          category_name
          cc_category_id
          ccid
          created_at
          description
          icd9_code
          id
          is_child_bearing
          name
          updated_at
        }
        created_at
        ethnicity
        gender
        height_max_in
        height_min_in
        id
        interaction_frequency
        last_interaction_date
        location_coordinates
        location_radius_miles
        medications {
          category_name
          ccid
          created_at
          default_route_id
          default_route_id_name
          description
          id
          is_child_bearing
          name
          updated_at
        }
        name
        participation_status
        preferred_contact_method
        preferred_language
        previous_trial_participation
        race
        response_status
        smoker_status
        subject_count
        subject_filters_json
        trial_phase
        updated_at
        weight_max_lb
        weight_min_lb
      }
      sites {
        ccid
        created_at
        id
        site_address_line1
        site_address_line2
        site_city
        site_country
        site_description
        site_name
        site_postal_code
        site_state
        subject_count
        updated_at
      }
      studies {
        agent_booked_appointment_text
        agent_needs_callback_text
        agent_precall_text
        ava_bot_alias_id
        ava_bot_config
        ava_bot_id
        ava_state_machine
        ccid
        contact_flow_id
        created_at
        end_date
        id
        protocol_extract_json
        site_description
        site_id
        site_name
        sponsor_id
        sponsor_name
        start_date
        status
        study_category
        study_cc_visits {
          id
          name
        }
        study_description
        study_name
        subject_count
        subject_protocol_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        text_agent_name
        updated_at
        visit_name
        voice_agent_name
      }
      subjects {
        active_enrollment_status
        age
        alcohol_use_frequency
        bmi
        ccid
        created_at
        crid
        current_study_id
        current_study_name
        date_of_birth
        diet_type
        ethnicity
        first_name
        full_name_first
        full_name_last
        gender
        height_cm
        height_in
        id
        is_possible_duplicate
        last_contact_outcomes
        last_contact_started_at
        last_name
        last_task_id
        last_touchpoint
        lead_created_at
        lifestyle_notes
        marital_status
        middle_name
        next_appt
        next_task_id
        next_touchpoint
        physical_activity_level
        preferred_language
        q_currently_in_clinical_trial
        q_date_of_last_dose
        q_date_of_last_visit
        q_ever_in_clinical_trial
        race
        ready_to_contact
        recruitment_source_name
        sleep_hours
        smoker_status
        sms_opt_in
        statuses
        stress_level
        subject_addresses {
          address_line1
          address_line2
          city
          country
          created_at
          id
          postal_code
          preferred
          state
          subject_id
          updated_at
        }
        subject_allergies {
          allergy_id
          allergy_id_allergen_description
          allergy_id_allergen_type
          allergy_id_cc_allergen_id
          allergy_id_ccid
          allergy_id_description
          allergy_id_is_default
          allergy_id_name
          allergy_name
          allergy_type
          created_at
          id
          notes
          reaction
          severity
          subject_id
          updated_at
        }
        subject_appointments {
          cc_appointment_id
          cc_patient_id
          cc_proposal_id
          cc_status
          cc_study_id
          created_at
          end_at
          id
          start_at
          subject_id
          updated_at
        }
        subject_contacts {
          ai_platform
          channel
          city
          contact_id
          created_at
          duration_seconds
          ended_at
          first_name
          full_name_first
          full_name_last
          last_name
          next_task_id
          next_touchpoint
          outcome
          outcomes
          phone_number
          purpose
          recording_bucket
          recording_key
          recording_url
          recruitment_id
          recruitment_source_name
          started_at
          subject_id
          summary
          transcript_bucket
          transcript_json
          transcript_key
          transcript_url
          updated_at
          wss_url
        }
        subject_deal_status {
          created_at
          deal_description
          deal_id
          deal_name
          status
          id
          subject_id
          updated_at
        }
        subject_emails {
          created_at
          email_address
          id
          preferred
          subject_id
          updated_at
        }
        subject_emergency_contacts {
          created_at
          email_address
          id
          name
          phone_number
          relationship_to_patient
          subject_id
          updated_at
        }
        subject_enrollment_status {
          ava_bot_alias_id
          ava_bot_config
          ava_bot_id
          ava_state_machine
          ccid
          contact_flow_id
          contact_name
          created_at
          enrollment_status
          id
          notes
          recruitment_id
          source_description
          source_name
          study_ava_bot_alias_id
          study_ava_bot_config
          study_ava_bot_id
          study_ava_state_machine
          study_category
          study_ccid
          study_contact_flow_id
          study_description
          study_enrollment_status_is_complete
          study_enrollment_status_priority
          study_id
          study_name
          study_visit_name
          subject_id
          updated_at
        }
        subject_family_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          created_at
          family_member
          id
          notes
          subject_id
          updated_at
        }
        subject_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          condition_status
          created_at
          diagnosed_date
          id
          notes
          resolved_date
          subject_id
          updated_at
        }
        subject_medications {
          created_at
          dosage_and_frequency
          end_date
          id
          medication_id
          medication_id_category_name
          medication_id_ccid
          medication_id_default_route_id
          medication_id_description
          medication_id_is_child_bearing
          medication_id_name
          medication_name
          notes
          prescribed_by
          reason_for_use
          route_id
          route_id_name
          start_date
          subject_id
          updated_at
        }
        subject_notes {
          created_at
          created_by
          id
          note
          subject_id
          updated_at
        }
        subject_phone_numbers {
          best_days_to_call
          best_time_to_call_end
          best_time_to_call_start
          created_at
          id
          phone_number
          phone_type
          preferred
          sms_opt_in
          subject_id
          updated_at
        }
        subject_physicians {
          address_line1
          address_line2
          city
          country
          created_at
          fax_number
          id
          last_exam_date
          name
          phone_number
          postal_code
          primary
          provider_type
          state
          subject_id
          updated_at
        }
        subject_recruitment_sources {
          created_at
          id
          notes
          recruitment_id
          source_description
          source_name
          subject_id
          updated_at
        }
        subject_statuses {
          created_at
          id
          status
          subject_id
          updated_at
        }
        subject_workflows {
          created_at
          id
          last_task_id
          last_touchpoint
          next_task_id
          next_touchpoint
          subject_id
          tasks_json
          updated_at
          workflow_id
          workflow_name
          workflow_tasks_json
        }
        title
        updated_at
        viewed_active_deal_page
        weight_kg
        weight_lb
      }
      subject_contacts {
        ai_platform
        channel
        city
        contact_id
        created_at
        duration_seconds
        ended_at
        first_name
        full_name_first
        full_name_last
        last_name
        next_task_id
        next_touchpoint
        outcome
        outcomes
        phone_number
        purpose
        recording_bucket
        recording_key
        recording_url
        recruitment_id
        recruitment_source_name
        started_at
        subject_id
        summary
        transcript_bucket
        transcript_json
        transcript_key
        transcript_url
        updated_at
        wss_url
      }
      table_changelog {
        cognito_sub
        created_at
        field_name
        id
        old_value
        new_value
        request_id
        subject_id
        table_id
        table_name
      }
      total_count
      workflows {
        agent_prompt
        created_at
        description
        id
        is_active
        name
        next_touchpoint_counts_json
        recruitment_id
        recruitment_parent_id
        recruitment_parent_source_name
        recruitment_source_name
        study_id
        study_name
        subject_count
        subject_filters_json
        tasks_json
        text_agent_name
        updated_at
        voice_agent_name
      }
    }
  }
`;
